import { Component, EventEmitter, Input, Output } from "@angular/core";
import {
    ITCIMarketplaceListing,
    TCI_MARKETPLACE_ACTIONS,
    TCI_MARKETPLACE_NOTIFICATION_TYPE
} from "@tci/common";
import { NgMarketplaceV2Service } from "../../ng-marketplace-v2.service";
import { NgToastrService } from "../../../ng-shared/ng-components/ng-toastr/ng-toastr.service";

@Component({
    selector: "ng-marketplace-v2-request-rejected",
    templateUrl: "./ng-marketplace-v2-request-rejected.component.html",
    styleUrls: ["./ng-marketplace-v2-request-rejected.component.less"]
})
export class NgMarketplaceV2RequestRejectedComponent {
    @Input() asset: ITCIMarketplaceListing;
    @Input() enabled = false;
    @Output() closePopup = new EventEmitter();
    @Output() isBusy: EventEmitter<boolean> = new EventEmitter();

    showPopup = false;

    private _busy: boolean;
    get busy() {
        return this._busy;
    }
    set busy(val: boolean) {
        this._busy = val;
        this.isBusy.emit(val);
    }

    constructor(
        private mktSvc: NgMarketplaceV2Service,
        private toastrSvc: NgToastrService
    ) {
    }

    private init() {
        this.showPopup = false;
        this.busy = false;
    }

    togglePopup() {
        if (!this.showPopup) {
            this.showPopup = true;
        } else {
            this.callClosePopup();
        }
    }

    callClosePopup() {
        this.showPopup = false;
        this.closePopup.emit();
    }

    doAknowledged() {
        this.busy = true;
        return this.mktSvc.processAction({ actionType: TCI_MARKETPLACE_ACTIONS.AcknowledgeReject, listing: this.asset })
            .subscribe(res => {
                if (res.success) {
                    this.mktSvc.notifyChange({ listing: res.data[0], type: TCI_MARKETPLACE_NOTIFICATION_TYPE.Update });
                } else {
                    this.toastrSvc.error(res.error.message);
                }

                this.init();
                return res.success;
            });
    }
}
